import React from 'react';
import { ForgeTaskType } from '../../types';
import { FDClassificationUI } from './FDClassificationUI';
import { UncertainClassificationUI } from './UncertainClassificationUI';
import { VariantCuratorUI } from './VariantCuratorUI';
import { VariantReviewUI } from './VariantReviewUI';

interface TaskTypeEntry {
  component: React.FC<{ payload: any; onSelect: (data: any) => void }>;
  label: string;
  shortLabel: string;
}

export const TASK_TYPE_REGISTRY: Record<ForgeTaskType, TaskTypeEntry> = {
  VARIANT_REVIEW: {
    component: VariantReviewUI,
    label: 'Variant Review',
    shortLabel: 'Review',
  },
  VARIANT_CURATOR: {
    component: VariantCuratorUI,
    label: 'Variant Curator',
    shortLabel: 'Curator',
  },
  UNCERTAIN_CLASSIFICATION: {
    component: UncertainClassificationUI,
    label: 'Uncertain Classification',
    shortLabel: 'Uncertain',
  },
  FD_CLASSIFICATION: {
    component: FDClassificationUI,
    label: 'FD Classification',
    shortLabel: 'FD Review',
  },
};
